import {AnyAction} from 'redux'
import {SEND_RSVP_OLD, sendRsvp} from '../actions/rsvp'

export const guest = (state = {}, action: AnyAction) => {
  switch (action.type) {
    case SEND_RSVP_OLD.SUCCESS:
    case sendRsvp.fulfilled.toString():
      return action.payload.rsvp
    default:
      return state
  }
}
